export enum AssignmentStatus {
  PENDING = 'PENDING',
  SUSPENDED = 'SUSPENDED',
  IN_PROCESS = 'IN_PROCESS',
  FINISHED = 'FINISHED',
}
